import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-trial-run-pill',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  template: `
    <span
      class="trial-run-pill"
      data-testid="lauf-probelauf-pille"
      [attr.title]="'testRuns.trialPill.title' | translate"
    >
      {{ (short() ? 'testRuns.trialPill.short' : 'testRuns.trialPill.label') | translate }}
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
    }

    .trial-run-pill {
      display: inline-flex;
      align-items: center;
      gap: 0.375rem;
      padding: 0.25rem 0.6875rem;
      border-radius: 999px;
      border: 1px dashed var(--tf-border);
      background: var(--tf-card);
      color: var(--tf-text-muted);
      font-size: 0.75rem;
      font-weight: 700;
      white-space: nowrap;
    }
  `,
})
export class TrialRunPillComponent {
  /** Nur „Probelauf“, für enge Spalten; der Titel nennt weiter, dass der Lauf nicht zählt. */
  readonly short = input(false);
}
